import styled from '@emotion/styled';

const OutlinedButton = styled.button`
  font-size: ${(props) => (props.fontSize ? `${props.fontSize}` : '16px')} !important;
  font-weight: ${(props) => (props.fontWeight ? `${props.fontWeight}` : '500')} !important;
  background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : 'transparent')};
  padding: ${(props) => {
    switch (props.size) {
      case 'small':
        return '4px 8px';
      case 'medium':
        return '8px 10px';
      case 'modal':
        return '10px 18px';
      default:
        return '8px 16px';
    }
  }};
  color: ${(props) => (props.color ? props.color : '#7F38E9')};
  border-width: ${(props) => (props.borderWidth ? props.borderWidth : '1px')};
  border-style: solid;
  border-color: ${(props) => (props.borderColor ? props.borderColor : props.color ? props.color : '#7F38E9')};
  border-radius: 4px;
  cursor: pointer;
  outline: none;
  transition: all 0.1s linear;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  width: ${(props) => (props.width ? `${props.width}` : 'auto')};
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  &:hover {
    opacity: 0.95;
  }
  &:active {
    transform: scale(0.95);
  }
  &:disabled {
    border-color: ${(props) => (props.borderColor ? props.borderColor : '#bf9cf4')};
    color: ${(props) => (props.color ? props.color : ' #bf9cf4')};
    background: transparent;
    cursor: not-allowed;
  }
`;

export default OutlinedButton;
